import type { ZoneType } from '../types/core';
import { pick } from '../utils/random';

const firstNames = [
  'Emma',
  'Oliver',
  'Amelia',
  'Noah',
  'Isla',
  'George',
  'Ava',
  'Arthur',
  'Freya',
  'Leo',
  'Maya',
  'Theo',
  'Grace',
  'Oscar',
  'Lily',
  'Finley',
  'Eleanor',
  'Henry',
  'Ruby',
  'Jasper',
  'Sienna',
  'Alfie',
  'Ivy',
  'Milo'
] as const;

const surnames = [
  'Bennett',
  'Hughes',
  'Patel',
  'Williams',
  'Clarke',
  'Evans',
  'Turner',
  'Morgan',
  'Cooper',
  'Foster',
  'Bailey',
  'Edwards',
  'Kaur',
  'Morris',
  'Brooks',
  'Reed'
] as const;

const streetNames = [
  'Oak Street',
  'Honey Lane',
  'Market Row',
  'Beech Road',
  'Station Approach',
  'Bramble Close',
  'Abbey Way',
  'Mill Street',
  'Lavender Mews',
  'Foxglove Terrace',
  'Kingfisher Road',
  'Crown Yard'
] as const;

const businessNames: Record<ZoneType, readonly string[]> = {
  residential: ['House', 'Home', 'Cottage', 'Terrace'],
  commercial: ['Cafe', 'Bakery', 'Pub', 'Corner Shop', 'Pharmacy', 'Market'],
  workspace: ['Workshop', 'Studio', 'Office', 'Library', 'Depot'],
  park: ['Green', 'Play Park', 'Community Garden', 'Pocket Park']
};

export function citizenName(rng: () => number): string {
  return `${pick(firstNames, rng)} ${pick(surnames, rng)}`;
}

export function buildingName(zone: ZoneType, rng: () => number): string {
  const street = pick(streetNames, rng);
  const suffix = pick(businessNames[zone], rng);

  if (zone === 'residential') {
    return `${street} ${suffix}`;
  }

  if (zone === 'park') {
    return `${street} ${suffix}`;
  }

  return `${pick(['The', 'Little', 'Old', 'Golden', 'Busy'], rng)} ${street} ${suffix}`;
}
